import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import MultiSelect from "react-multi-select-component";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import {
  getDailyNavByFromDateToDate,
  getFundByAmc,
} from "../../stores/services/funds.service";
// import { getBankStatement,getBankStatementOpeningBalance } from '../../stores/services/report.service';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import {
  exportToTxt,
  generateExcel,
  numberWithCommas,
} from "../../utils/customFunction";
import { getPsxIndicesByFromToDate } from "../../stores/services/security.service";
import { useSelector } from "react-redux";
import Select from "react-select";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import html2pdf from "html2pdf.js";

const AnalysisNavReport = () => {
  const contentRef = React.useRef(null);

  const ColumnHeading = [
    { label: "Date", value: "Date" },
    { label: "NAV Current", value: "NAV Current" },
    { label: "NAV Previous", value: "NAV Previous" },
    { label: "Change in NAV(Rs)", value: "Change in NAV(Rs)" },
    { label: "% Change in NAV", value: "% Change in NAV" },
    { label: "% Change in KSE-100", value: "% Change in KSE-100" },
    { label: "% Change in KSE-30", value: "% Change in KSE-30" },
  ];
  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: ["Opening Balance", "Closing Balance"],
  });
  const [fontSizeVal, setFontSizeVal] = useState<any>(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const [itemsPerPage, setItemsPerPage] = useState<any>(10);
  const [itemsToShow, setItemsToShow] = useState(10);
  const [isSearchTrue, setIsSearchTrue] = useState(false);

  const [screen, setScreen] = useState<any>();
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const [loading, setLoading] = useState(false);
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  let date = new Date();
  const [analysisNavData, setAnalysisNavData] = useState<any>([]);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [fundCode, setFundCode] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [navFromDate, setNavFromDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [navToDate, setNavToDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [resAmc, setResAmc] = useState("");
  const [resFund, setResFund] = useState("");
  const [resNavFromDate, setResNavFromDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [resNavToDate, setResNavToDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );

  const [repotNavData, setReportNavData] = useState([]);
  const [reportIndiceData, setReportIndiceData] = useState<any>([]);
  const [kse100Data, setKse100Data] = useState<any>([]);
  const [kse30Data, setKse30Data] = useState<any>([]);
  const [kmi30Data, setKmi30Data] = useState<any>([]);

  const getAllAmcFunds = async () => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) { }
  };

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  // useEffect(() => {

  //   getAllAmcFunds();
  // }, []);

  // let txnTypes = JSON.parse(sessionStorage.getItem('txnType') || '');

  // const CapTxnType = (type: any) => {
  //     let i, txType;
  //     for (i = 0; i < txnTypes.length; i++) {
  //     if (txnTypes[i].api_name === type) {
  //         txType = txnTypes[i].dis_name;
  //         break;
  //     }
  //     }
  //     return txType;
  // };

  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };

  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  //code for search data for Reports

  const searchData = async () => {
    setIsSearchTrue(false);
    setItemsPerPage(10);
    setAnalysisNavData([]);
    try {
      if (navFromDate === navToDate) {
        toast.error("Dates can't be same!");
        return;
      }
      setLoading(true);

      let kse100: any;
      let kse30: any;
      let kmi30: any;

      setResAmc(amc_name);
      setResFund(fund);
      setResNavFromDate(navFromDate);
      setResNavToDate(navToDate);

      try {
        const response = await getDailyNavByFromDateToDate(
          email,
          amc_code,
          fundCode,
          navFromDate,
          navToDate
        );
        if (
          response &&
          response.status === 200 &&
          response.data.status === 200
        ) {
          setReportNavData(response.data.data);
        } else {
          toast.error("No data found!");
          setLoading(false);
        }

        const response2 = await getPsxIndicesByFromToDate(
          email,
          amc_code,
          navFromDate,
          navToDate
        );
        if (
          response2 &&
          response2.status === 200 &&
          response2.data.status === 200
        ) {
          kse100 = response2.data.data
            .filter((item) => item.index_symbol.toLowerCase() === "kse100")
            .sort((a, b) => a.time - b.time);

          kse30 = response2.data.data
            .filter((item) => item.index_symbol.toLowerCase() === "kse30")
            .sort((a, b) => a.time - b.time);

          kmi30 = response2.data.data
            .filter((item) => item.index_symbol.toLowerCase() === "kmi30")
            .sort((a, b) => a.time - b.time);

          setKse100Data(kse100 || []);
          setKse30Data(kse30 || []);
          setKmi30Data(kmi30 || []);
          setReportIndiceData(response2.data.data);
        } else {
          toast.error("Error fetching index data!");
        }

        if (response && response2) {
          let allDatesWithinRange: any = [];
          let startDate: any = navFromDate;

          while (startDate !== navToDate) {
            let temp = moment(startDate).add(1, "day").format("YYYY-MM-DD");
            allDatesWithinRange.push({
              from: startDate,
              to: temp,
              // fromNAV: response?.data?.data?.find(
              //   (item) =>
              //     item.created_at_time >
              //       new Date(
              //         new Date(startDate).setHours(0, 0, 0, 0)
              //       ).getTime() &&
              //     item.created_at_time <
              //       new Date(new Date(startDate).setHours(23, 59, 59)).getTime()
              // ),
              // toNAV: response?.data?.data?.find(
              //   (item) =>
              //     item.created_at_time >
              //       new Date(new Date(temp).setHours(0, 0, 0, 0)).getTime() &&
              //     item.created_at_time <
              //       new Date(new Date(temp).setHours(23, 59, 59)).getTime()
              // ),
              fromNAV: response?.data?.data?.find(
                (item) =>
                  item.nav_time >
                  new Date(
                    new Date(startDate).setHours(0, 0, 0, 0)
                  ).getTime() &&
                  item.nav_time <
                  new Date(new Date(startDate).setHours(23, 59, 59)).getTime()
              ),
              toNAV: response?.data?.data?.find(
                (item) =>
                  item.nav_time >
                  new Date(new Date(temp).setHours(0, 0, 0, 0)).getTime() &&
                  item.nav_time <
                  new Date(new Date(temp).setHours(23, 59, 59)).getTime()
              ),
              fromKSE100: kse100?.find((item) => item.date === startDate),
              toKSE100: kse100?.find((item) => item.date === temp),
              fromKSE30: kse30?.find((item) => item.date === startDate),
              toKSE30: kse30?.find((item) => item.date === temp),
            });
            startDate = temp;
          }

          setAnalysisNavData(allDatesWithinRange);
        }

        setLoading(false);
      } catch (error) {
        toast.error("Error fetching data!");
        setLoading(false);
      }
      setIsSearchTrue(true);
      setFontSizeVal(18);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setIsSearchTrue(false);
      if (error.response != undefined) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };

  const calculatePercentage = (a, b) => {
    let percent;
    if (b !== 0) {
      if (a !== 0) {
        percent = ((b - a) / a) * 100;
      } else {
        percent = b * 100;
      }
    } else {
      percent = -a * 100;
    }
    // return Math.floor(percent);

    return percent;
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund = allFunds.find(
      (item) => item?.symbol_code === fundCode
    );
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
      }
      : null;
  }, [allFunds, fundCode]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  const fixedOrder = [
    "Date",
    "NAV Current",
    "NAV Previous",
    "Change in NAV(Rs)",
    "% Change in NAV",
    "% Change in KSE-100",
    "% Change in KSE-30",
  ];

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test"
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

  useEffect(() => {
    const handleScreenResize = () => {
      setScreen(window?.outerWidth);
    };

    window.addEventListener("resize", handleScreenResize);
    handleScreenResize();

    return () => {
      window.removeEventListener("resize", handleScreenResize);
    };
  }, []);

  const handleDownloadSampleFile = () => {
    const headings = [
      [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
      [
        selectedValues?.sub_heading ? selectedValues?.sub_heading : "",
        "",
        "",
        "",
      ],
      [
        "Fund",
        `${resFund}`,
        "Nav From",
        `${moment(resNavFromDate).format("DD-MMM-YY")}`,
      ],
      [
        "Report Date",
        `${moment().format("DD-MMM-YY")}`,
        "Nav To",
        `${moment(resNavToDate).format("DD-MMM-YY")}`,
      ],
      [
        "Index",
        "As on " + moment(navToDate).format("DD-MMM-YYYY"),
        "As on " + moment(navFromDate).format("DD-MMM-YYYY"),
        "Pts. Change",
      ],
      kse100Data &&
      kse100Data.length > 0 && [
        "KSE-100 Index",
        numberWithCommas(
          parseFloat(
            kse100Data.find((item) => item.date === navToDate)?.price || 0
          ).toFixed(4)
        ),
        numberWithCommas(
          parseFloat(
            kse100Data.find((item) => item.date === navFromDate)?.price || 0
          ).toFixed(4)
        ),
        kse100Data.find((item) => item.date === navFromDate)?.price -
        kse100Data.find((item) => item.date === navToDate)?.price || 0,
      ],
      kse30Data &&
      kse30Data.length > 0 && [
        "KSE-30 Index",
        numberWithCommas(
          parseFloat(
            kse30Data.find((item) => item.date === navToDate)?.price || 0
          ).toFixed(4)
        ),
        numberWithCommas(
          parseFloat(
            kse30Data.find((item) => item.date === navFromDate)?.price || 0
          ).toFixed(4)
        ),
        kse30Data.find((item) => item.date === navFromDate)?.price -
        kse30Data.find((item) => item.date === navToDate)?.price || 0,
      ],
      kmi30Data &&
      kmi30Data.length > 0 && [
        "KMI-30 Index",
        numberWithCommas(
          parseFloat(
            kmi30Data.find((item) => item.date === navToDate)?.price || 0
          ).toFixed(4)
        ),
        numberWithCommas(
          parseFloat(
            kmi30Data.find((item) => item.date === navFromDate)?.price || 0
          ).toFixed(4)
        ),
        kmi30Data.find((item) => item.date === navFromDate)?.price -
        kmi30Data.find((item) => item.date === navToDate)?.price || 0,
      ],
    ];

    const dataSequence = analysisNavData
      ?.map((ele) => {
        if (
          (!ele?.toNAV || ele?.toNAV?.nav === 0) &&
          (!ele?.fromNAV || ele?.fromNAV?.nav === 0)
        ) {
          return null;
        } else {
          return ele;
        }
      })
      ?.filter(Boolean)
      ?.slice(0, itemsToShow)
      ?.map((item, index) => {
        if (
          (!item?.toNAV || item?.toNAV?.nav === 0) &&
          (!item?.fromNAV || item?.fromNAV?.nav === 0)
        ) {
          return null;
        } else {
          return {
            Date: moment(item.to).format("DD-MM-YYYY"),
            NAV_Current: numberWithCommas((item?.toNAV?.nav || 0).toFixed(4)),
            NAV_Previous: numberWithCommas(
              (item?.fromNAV?.nav || 0).toFixed(4)
            ),
            Change_in_NAV_Rs: numberWithCommas(
              ((item?.toNAV?.nav || 0) - (item?.fromNAV?.nav || 0)).toFixed(4)
            ),
            Percentage_Change_in_NAV: numberWithCommas(
              calculatePercentage(
                item?.fromNAV?.nav || 0,
                item?.toNAV?.nav || 0
              ).toFixed(4)
            ),
            Percentage_Change_in_KSE_100: item?.toKSE100
              ? parseFloat(item?.toKSE100.change_rate_yesterday || 0)?.toFixed(
                4
              )
              : "-",
            Percentage_Change_in_KSE_30: item?.toKSE30
              ? parseFloat(item?.toKSE30.change_rate_yesterday || 0)?.toFixed(4)
              : "-",
          };
        }
      });

    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Date") {
            result[column] = entry?.Date;
          } else if (column === "NAV Current") {
            result[column] = entry?.NAV_Current;
          } else if (column === "NAV Previous") {
            result[column] = entry?.NAV_Previous;
          } else if (column === "Change in NAV(Rs)") {
            result[column] = entry?.Change_in_NAV_Rs;
          } else if (column === "% Change in NAV") {
            result[column] = entry?.Percentage_Change_in_NAV;
          } else if (column === "% Change in KSE-100") {
            result[column] = entry?.Percentage_Change_in_KSE_100;
          } else if (column === "% Change in KSE-30") {
            result[column] = entry?.Percentage_Change_in_KSE_30;
          }
        });
        return result;
      });

    generateExcel(
      "NAV Analysis Report",
      "NAV Analysis Report",
      "File",
      "File",
      "DCCL",
      headings,
      reorderedColumns,
      ArrayData,
      [],
      []
    );
  };

  const handleTXT = () => {
    const dataSequence = analysisNavData
      ?.map((ele) => {
        if (
          (!ele?.toNAV || ele?.toNAV?.nav === 0) &&
          (!ele?.fromNAV || ele?.fromNAV?.nav === 0)
        ) {
          return null;
        } else {
          return ele;
        }
      })
      ?.filter(Boolean)
      ?.slice(0, itemsToShow)
      ?.map((item, index) => {
        if (
          (!item?.toNAV || item?.toNAV?.nav === 0) &&
          (!item?.fromNAV || item?.fromNAV?.nav === 0)
        ) {
          return null;
        } else {
          return {
            Date: moment(item.to).format("DD-MM-YYYY"),
            NAV_Current: numberWithCommas((item?.toNAV?.nav || 0).toFixed(4)),
            NAV_Previous: numberWithCommas(
              (item?.fromNAV?.nav || 0).toFixed(4)
            ),
            Change_in_NAV_Rs: numberWithCommas(
              ((item?.toNAV?.nav || 0) - (item?.fromNAV?.nav || 0)).toFixed(4)
            ),
            Percentage_Change_in_NAV: numberWithCommas(
              calculatePercentage(
                item?.fromNAV?.nav || 0,
                item?.toNAV?.nav || 0
              ).toFixed(4)
            ),
            Percentage_Change_in_KSE_100: item?.toKSE100
              ? parseFloat(item?.toKSE100.change_rate_yesterday || 0)?.toFixed(
                4
              )
              : "-",
            Percentage_Change_in_KSE_30: item?.toKSE30
              ? parseFloat(item?.toKSE30.change_rate_yesterday || 0)?.toFixed(4)
              : "-",
          };
        }
      });

    const reorderColumns = (columns, order) => {
      return order.filter((column) => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(
      selectedValues?.columns,
      fixedOrder
    );

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const result = {};
        reorderedColumns.forEach((column) => {
          if (column === "Date") {
            result[column] = entry?.Date;
          } else if (column === "NAV Current") {
            result[column] = entry?.NAV_Current;
          } else if (column === "NAV Previous") {
            result[column] = entry?.NAV_Previous;
          } else if (column === "Change in NAV(Rs)") {
            result[column] = entry?.Change_in_NAV_Rs;
          } else if (column === "% Change in NAV") {
            result[column] = entry?.Percentage_Change_in_NAV;
          } else if (column === "% Change in KSE-100") {
            result[column] = entry?.Percentage_Change_in_KSE_100;
          } else if (column === "% Change in KSE-30") {
            result[column] = entry?.Percentage_Change_in_KSE_30;
          }
        });
        return result;
      });

    let formattedContent = `${selectedValues?.heading ? selectedValues?.heading : ""
      },,,\n`;
    formattedContent += `${selectedValues?.sub_heading ? selectedValues?.sub_heading : ""
      },,,\n`;
    formattedContent += `"Fund:","${resFund}",`;
    formattedContent += `"Nav From:","${moment(resNavFromDate).format(
      "DD-MMM-YY"
    )}",,\n`;
    formattedContent += `"Report Date:","${moment().format("DD-MMM-YY")}",`;
    formattedContent += `"Nav To:","${moment(resNavToDate).format(
      "DD-MMM-YY"
    )}",,\n`;

    formattedContent += `"Index","As on ${moment(navToDate).format(
      "DD-MMM-YYYY"
    )}","As on ${moment(navFromDate).format("DD-MMM-YYYY")}","Pts. Change",\n`;

    if (kse100Data && kse100Data.length > 0) {
      const kse100Current = numberWithCommas(
        parseFloat(
          kse100Data.find((item) => item.date === navToDate)?.price || 0
        ).toFixed(4)
      );
      const kse100Previous = numberWithCommas(
        parseFloat(
          kse100Data.find((item) => item.date === navFromDate)?.price || 0
        ).toFixed(4)
      );
      const kse100Change =
        kse100Data.find((item) => item.date === navFromDate)?.price -
        kse100Data.find((item) => item.date === navToDate)?.price || 0;
      formattedContent += `"KSE-100 Index","${kse100Current}","${kse100Previous}","${kse100Change}",\n`;
    }

    if (kse30Data && kse30Data.length > 0) {
      const kse30Current = numberWithCommas(
        parseFloat(
          kse30Data.find((item) => item.date === navToDate)?.price || 0
        ).toFixed(4)
      );
      const kse30Previous = numberWithCommas(
        parseFloat(
          kse30Data.find((item) => item.date === navFromDate)?.price || 0
        ).toFixed(4)
      );
      const kse30Change =
        kse30Data.find((item) => item.date === navFromDate)?.price -
        kse30Data.find((item) => item.date === navToDate)?.price || 0;
      formattedContent += `"KSE-30 Index","${kse30Current}","${kse30Previous}","${kse30Change}",\n`;
    }

    if (kmi30Data && kmi30Data.length > 0) {
      const kmi30Current = numberWithCommas(
        parseFloat(
          kmi30Data.find((item) => item.date === navToDate)?.price || 0
        ).toFixed(4)
      );
      const kmi30Previous = numberWithCommas(
        parseFloat(
          kmi30Data.find((item) => item.date === navFromDate)?.price || 0
        ).toFixed(4)
      );
      const kmi30Change =
        kmi30Data.find((item) => item.date === navFromDate)?.price -
        kmi30Data.find((item) => item.date === navToDate)?.price || 0;
      formattedContent += `"KMI-30 Index","${kmi30Current}","${kmi30Previous}","${kmi30Change}",\n`;
    }
    exportToTxt(
      formattedContent,
      selectedValues,
      ArrayData,
      "NAV Analysis Report"
    );
  };

  const handleShowMore = () => {
    setItemsToShow((prev) => prev + itemsPerPage);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "Analysic-Nav-Report.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 10, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf().from(element).set(options).save();
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    {/* <h4 className="card-title">Voucher Report</h4> */}
                    <h4 className="card-title">NAV Analysis Report</h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFundName}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setReportNavData([]);
                              setAnalysisNavData([]);
                              setFund(e?.label);
                              setFundCode(e?.value);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setReportNavData([]);
                              setFund(
                                e.nativeEvent.target == null
                                  ? ""
                                  : e.nativeEvent.target[e.target.selectedIndex]
                                    .text
                              );
                              setFundCode(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group  ">
                          {/* <label>Select from Date</label> */}
                          <label>From Date</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={navFromDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              setReportNavData([]);

                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setNavFromDate(date);
                              setAnalysisNavData([]);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group  ">
                          {/* <label>Select to Date</label> */}
                          <label>To Date</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={navToDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              setReportNavData([]);
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setNavToDate(date);
                              setAnalysisNavData([]);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="mt-1">
                          {/* here Search Button */}
                          <button
                            style={{
                              paddingTop: "8px",
                              paddingBottom: "8px",
                            }}
                            className="btn btn-primary mt-4"
                            disabled={
                              !fundCode ||
                              fundCode === "" ||
                              !navFromDate ||
                              !navToDate ||
                              loading
                            }
                            onClick={() => {
                              searchData();
                            }}
                          // disabled={Boolean(loading)}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    {/* End */}
                  </div>
                </div>

                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {/* ------------------ Report template starts here ---------- */}
                    {analysisNavData.length > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={"Analysic-Nav-Report-" + date + ".pdf"}
                          printExcel={handleDownloadSampleFile}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}
                    {/* ------------------ Report template ends here ---------- */}
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        // background: "white",
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${dimensionOfPages?.find(
                            (item) => item?.key == paperSizeVal
                          )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                            }`,
                          height: "auto",
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <PDFExport
                          paperSize={paperSizeVal || "A4"}
                          margin="1.5cm"
                          // margin={{ top: marginPDF, left: marginPDF, right: marginPDF, bottom: "1.13cm" }}
                          scale={scalePDF}
                          landscape={layoutVal === "Landscape" ? true : false}
                          repeatHeaders={true}
                          fileName={"Analysic-Nav-Report-" + date + ".pdf"}
                          ref={pdfExportComponent}
                        >
                          <div
                            style={{
                              margin: "0.25in"
                            }}
                            ref={contentRef}>
                            {!loading &&
                              fundCode &&
                              navFromDate &&
                              navToDate &&
                              analysisNavData.length > 0 ? (
                              <>
                                <ReportHeader title={`NAV Analysis Report`} />

                                <Row>
                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Fund:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {resFund}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          NAV From:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(resNavFromDate).format(
                                            "DD-MMM-YY"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Report Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {/* {moment(date).format("DD-MM-YYYY")} */}
                                          {moment().format("DD-MMM-YY")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          NAV To:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span
                                          id="test"
                                          className="ReportTopStyling"
                                        >
                                          {moment(resNavToDate).format(
                                            "DD-MMM-YY"
                                          )}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                {selectedValues?.columns?.length > 0 ? (
                                  <div
                                    style={{
                                      overflowX: "auto",
                                      overflowY: "hidden",
                                    }}
                                  >
                                    <table
                                      className="report"
                                      style={{ color: "black" }}
                                    >
                                      <thead style={{ alignSelf: "center" }}>
                                        <tr>
                                          <th
                                            className="htmltoPdfStyle"
                                            id="test"
                                          >
                                            Index
                                          </th>

                                          <th
                                            id="test"
                                            className="text-right htmltoPdfStyle"
                                          >
                                            As on{" "}
                                            {moment(navToDate).format(
                                              "DD-MMM-YYYY"
                                            )}
                                          </th>
                                          <th
                                            id="test"
                                            className="text-right htmltoPdfStyle"
                                          >
                                            As on{" "}
                                            {moment(navFromDate).format(
                                              "DD-MMM-YYYY"
                                            )}
                                          </th>
                                          <th
                                            id="test"
                                            className="text-right htmltoPdfStyle"
                                          >
                                            Pts. Change
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="report-table-body">
                                        {kse100Data && kse100Data.length > 0 ? (
                                          <>
                                            <tr>
                                              <td
                                                className="htmltoPdfStyle"
                                                id="test"
                                              >
                                                KSE-100 Index
                                              </td>

                                              <td
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    kse100Data?.find(
                                                      (item) =>
                                                        item.date === navToDate
                                                    )?.price || 0
                                                  )?.toFixed(4)
                                                )}
                                              </td>
                                              <td
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    kse100Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navFromDate
                                                    )?.price || 0
                                                  )?.toFixed(4)
                                                )}
                                              </td>
                                              {(kse100Data?.find(
                                                (item) =>
                                                  item.date === navFromDate
                                              )?.price || 0) -
                                                (kse100Data?.find(
                                                  (item) =>
                                                    item.date === navToDate
                                                )?.price || 0) >
                                                0 ? (
                                                <td className="text-right">
                                                  <span
                                                    id="test"
                                                    className="text-success htmltoPdfStyle"
                                                  >
                                                    {numberWithCommas(
                                                      (kse100Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navFromDate
                                                      )?.price || 0) -
                                                      (kse100Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navToDate
                                                      )?.price || 0)
                                                    )}
                                                  </span>
                                                </td>
                                              ) : (kse100Data?.find(
                                                (item) =>
                                                  item.date === navFromDate
                                              )?.price || 0) -
                                                (kse100Data?.find(
                                                  (item) =>
                                                    item.date === navToDate
                                                )?.price || 0) <
                                                0 ? (
                                                <td className="text-right text-danger">
                                                  <span
                                                    id="test"
                                                    className="text-danger htmltoPdfStyle"
                                                  >
                                                    {numberWithCommas(
                                                      (kse100Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navFromDate
                                                      )?.price || 0) -
                                                      (kse100Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navToDate
                                                      )?.price || 0)
                                                    )}
                                                  </span>
                                                </td>
                                              ) : (
                                                <td
                                                  id="test"
                                                  className="text-right htmltoPdfStyle"
                                                >
                                                  {numberWithCommas(
                                                    (kse100Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navFromDate
                                                    )?.price || 0) -
                                                    (kse100Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navToDate
                                                    )?.price || 0)
                                                  )}
                                                </td>
                                              )}
                                            </tr>
                                          </>
                                        ) : null}

                                        {kse30Data && kse30Data.length > 0 ? (
                                          <>
                                            <tr>
                                              <td
                                                id="test"
                                                className="htmltoPdfStyle"
                                              >
                                                KSE-30 Index
                                              </td>

                                              <td
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    kse30Data?.find(
                                                      (item) =>
                                                        item.date === navToDate
                                                    )?.price || 0
                                                  )?.toFixed(4)
                                                )}
                                              </td>
                                              <td
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    kse30Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navFromDate
                                                    )?.price || 0
                                                  )?.toFixed(4)
                                                )}
                                              </td>
                                              {(kse30Data?.find(
                                                (item) =>
                                                  item.date === navFromDate
                                              )?.price || 0) -
                                                (kse30Data?.find(
                                                  (item) =>
                                                    item.date === navToDate
                                                )?.price || 0) >
                                                0 ? (
                                                <td className="text-right">
                                                  <span
                                                    id="test"
                                                    className="text-success htmltoPdfStyle"
                                                  >
                                                    {numberWithCommas(
                                                      (kse30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navFromDate
                                                      )?.price || 0) -
                                                      (kse30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navToDate
                                                      )?.price || 0)
                                                    )}
                                                  </span>
                                                </td>
                                              ) : (kse30Data?.find(
                                                (item) =>
                                                  item.date === navFromDate
                                              )?.price || 0) -
                                                (kse30Data?.find(
                                                  (item) =>
                                                    item.date === navToDate
                                                )?.price || 0) <
                                                0 ? (
                                                <td className="text-right text-danger">
                                                  <span
                                                    id="test"
                                                    className="text-danger htmltoPdfStyle"
                                                  >
                                                    {numberWithCommas(
                                                      (kse30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navFromDate
                                                      )?.price || 0) -
                                                      (kse30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navToDate
                                                      )?.price || 0)
                                                    )}
                                                  </span>
                                                </td>
                                              ) : (
                                                <td
                                                  id="test"
                                                  className="text-right htmltoPdfStyle"
                                                >
                                                  {numberWithCommas(
                                                    (kse30Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navFromDate
                                                    )?.price || 0) -
                                                    (kse30Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navToDate
                                                    )?.price || 0)
                                                  )}
                                                </td>
                                              )}
                                            </tr>
                                          </>
                                        ) : null}

                                        {kmi30Data && kmi30Data.length > 0 ? (
                                          <>
                                            <tr>
                                              <td
                                                className="htmltoPdfStyle"
                                                id="test"
                                              >
                                                KMI-30 Index
                                              </td>

                                              <td
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    kmi30Data?.find(
                                                      (item) =>
                                                        item.date === navToDate
                                                    )?.price || 0
                                                  )?.toFixed(4)
                                                )}
                                              </td>
                                              <td
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                {numberWithCommas(
                                                  parseFloat(
                                                    kmi30Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navFromDate
                                                    )?.price || 0
                                                  )?.toFixed(4)
                                                )}
                                              </td>
                                              {(kmi30Data?.find(
                                                (item) =>
                                                  item.date === navFromDate
                                              )?.price || 0) -
                                                (kmi30Data?.find(
                                                  (item) =>
                                                    item.date === navToDate
                                                )?.price || 0) >
                                                0 ? (
                                                <td className="text-right">
                                                  <span
                                                    id="test"
                                                    className="text-success htmltoPdfStyle"
                                                  >
                                                    {numberWithCommas(
                                                      (kmi30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navFromDate
                                                      )?.price || 0) -
                                                      (kmi30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navToDate
                                                      )?.price || 0)
                                                    )}
                                                  </span>
                                                </td>
                                              ) : (kmi30Data?.find(
                                                (item) =>
                                                  item.date === navFromDate
                                              )?.price || 0) -
                                                (kmi30Data?.find(
                                                  (item) =>
                                                    item.date === navToDate
                                                )?.price || 0) <
                                                0 ? (
                                                <td className="text-right text-danger">
                                                  <span
                                                    id="test"
                                                    className="text-danger htmltoPdfStyle"
                                                  >
                                                    {numberWithCommas(
                                                      (kmi30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navFromDate
                                                      )?.price || 0) -
                                                      (kmi30Data?.find(
                                                        (item) =>
                                                          item.date ===
                                                          navToDate
                                                      )?.price || 0)
                                                    )}
                                                  </span>
                                                </td>
                                              ) : (
                                                <td
                                                  id="test"
                                                  className="text-right htmltoPdfStyle"
                                                >
                                                  {numberWithCommas(
                                                    (kmi30Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navFromDate
                                                    )?.price || 0) -
                                                    (kmi30Data?.find(
                                                      (item) =>
                                                        item.date ===
                                                        navToDate
                                                    )?.price || 0)
                                                  )}
                                                </td>
                                              )}
                                            </tr>
                                          </>
                                        ) : null}
                                      </tbody>
                                    </table>

                                    <hr />

                                    <table
                                      className="report"
                                      style={{ color: "black" }}
                                    >
                                      <thead style={{ alignSelf: "center" }}>
                                        <tr>
                                          {/* <th className="text-right">{`NAV As of ${moment( */}
                                          {selectedValues?.columns?.includes(
                                            "Date"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                Date
                                              </th>
                                            )}
                                          {selectedValues?.columns?.includes(
                                            "NAV Current"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                NAV Current
                                              </th>
                                            )}
                                          {selectedValues?.columns?.includes(
                                            "NAV Previous"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                NAV Previous
                                              </th>
                                            )}
                                          {selectedValues?.columns?.includes(
                                            "Change in NAV(Rs)"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                Change in NAV(Rs)
                                              </th>
                                            )}
                                          {selectedValues?.columns?.includes(
                                            "% Change in NAV"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                % Change in NAV
                                              </th>
                                            )}
                                          {selectedValues?.columns?.includes(
                                            "% Change in KSE-100"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                % Change in KSE-100
                                              </th>
                                            )}
                                          {selectedValues?.columns?.includes(
                                            "% Change in KSE-30"
                                          ) && (
                                              <th
                                                id="test"
                                                className="text-right htmltoPdfStyle"
                                              >
                                                % Change in KSE-30
                                              </th>
                                            )}
                                        </tr>
                                      </thead>
                                      <tbody className="report-table-body">
                                        {analysisNavData
                                          ?.map((ele) => {
                                            if (
                                              (!ele?.toNAV ||
                                                ele?.toNAV?.nav === 0) &&
                                              (!ele?.fromNAV ||
                                                ele?.fromNAV?.nav === 0)
                                            ) {
                                              return null;
                                            } else {
                                              return ele;
                                            }
                                          })
                                          ?.filter(Boolean)
                                          ?.slice(0, itemsToShow)
                                          ?.map((item: any, index: number) => {
                                            if (
                                              (!item?.toNAV ||
                                                item?.toNAV?.nav === 0) &&
                                              (!item?.fromNAV ||
                                                item?.fromNAV?.nav === 0)
                                            ) {
                                              return null;
                                            }

                                            return (
                                              <tr key={index}>
                                                {selectedValues?.columns?.includes(
                                                  "Date"
                                                ) && (
                                                    <td
                                                      className="htmltoPdfStyle"
                                                      id="test"
                                                    >
                                                      {
                                                        moment(item.to).format(
                                                          "DD-MM-YYYY"
                                                        )
                                                        // +
                                                        //   " TO " +
                                                        //   moment(item.from).format(
                                                        //     "DD-MMM-YYYY"
                                                        //   )
                                                      }
                                                    </td>
                                                  )}
                                                {selectedValues?.columns?.includes(
                                                  "NAV Current"
                                                ) && (
                                                    <td
                                                      id="test"
                                                      className="text-right htmltoPdfStyle"
                                                    >
                                                      {numberWithCommas(
                                                        (
                                                          item?.toNAV?.nav || 0
                                                        ).toFixed(4)
                                                      )}
                                                    </td>
                                                  )}
                                                {selectedValues?.columns?.includes(
                                                  "NAV Previous"
                                                ) && (
                                                    <td
                                                      id="test"
                                                      className="text-right htmltoPdfStyle"
                                                    >
                                                      {numberWithCommas(
                                                        (
                                                          item?.fromNAV?.nav || 0
                                                        ).toFixed(4)
                                                      )}
                                                    </td>
                                                  )}
                                                {selectedValues?.columns?.includes(
                                                  "Change in NAV(Rs)"
                                                ) && (
                                                    <td
                                                      id="test"
                                                      className="text-right htmltoPdfStyle"
                                                    >
                                                      {numberWithCommas(
                                                        (
                                                          (item?.toNAV?.nav ||
                                                            0) -
                                                          (item?.fromNAV?.nav ||
                                                            0)
                                                        ).toFixed(4)
                                                      )}
                                                    </td>
                                                  )}
                                                {selectedValues?.columns?.includes(
                                                  "% Change in NAV"
                                                ) && (
                                                    <td
                                                      id="test"
                                                      className="text-right htmltoPdfStyle"
                                                    >
                                                      {numberWithCommas(
                                                        calculatePercentage(
                                                          item?.fromNAV?.nav || 0,
                                                          item?.toNAV?.nav || 0
                                                        ).toFixed(4)
                                                      )}
                                                    </td>
                                                  )}
                                                {selectedValues?.columns?.includes(
                                                  "% Change in KSE-100"
                                                ) && (
                                                    <td
                                                      id="test"
                                                      className="text-right htmltoPdfStyle"
                                                    >
                                                      {item?.toKSE100
                                                        ? parseFloat(
                                                          item?.toKSE100
                                                            .change_rate_yesterday ||
                                                          0
                                                        )?.toFixed(4)
                                                        : "-"}
                                                    </td>
                                                  )}
                                                {selectedValues?.columns?.includes(
                                                  "% Change in KSE-30"
                                                ) && (
                                                    <td
                                                      id="test"
                                                      className="text-right htmltoPdfStyle"
                                                    >
                                                      {item?.toKSE30
                                                        ? parseFloat(
                                                          item?.toKSE30
                                                            .change_rate_yesterday ||
                                                          0
                                                        )?.toFixed(4)
                                                        : "-"}
                                                    </td>
                                                  )}
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                ) : (
                                  <div className="text-center my-5">
                                    <b>No column selected</b>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center empty-text text-primary">
                                  No record found
                                </p>
                              </div>
                            )}
                          </div>
                        </PDFExport>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        {analysisNavData
                          ?.map((ele) => {
                            if (
                              (!ele?.toNAV || ele?.toNAV?.nav === 0) &&
                              (!ele?.fromNAV || ele?.fromNAV?.nav === 0)
                            ) {
                              return null;
                            } else {
                              return ele;
                            }
                          })
                          ?.filter(Boolean)?.length >= 10 &&
                          selectedValues?.columns?.length > 0 && (
                            <UncontrolledDropdown
                              className="me-2 mt-2"
                              direction="down"
                            >
                              <DropdownToggle
                                id="TotalRecord_dropdown"
                                style={{
                                  background: "none",
                                  padding: "0px",
                                  margin: "0px",
                                }}
                                className="border"
                              // style={{
                              //   borderRadius: "4px",
                              //   color: theme == "light" ? "black" : "",
                              // }}
                              // caret
                              // size="sm"
                              >
                                <div
                                  id="report_dropdown"
                                  style={{
                                    borderRadius: "4px",
                                    padding: "5px 15px",
                                    color: theme == "light" ? "black" : "white",
                                  }}
                                >
                                  Per page : {itemsPerPage}
                                </div>

                                {/* {selectedValues?.columns?.length > 0 &&
                                bankStatementDataCount > 0
                                ? bankStatement?.length
                                : 0} */}
                              </DropdownToggle>
                              <DropdownMenu
                                style={{
                                  // width: "100%",
                                  maxHeight: "300px",
                                  overflow: "auto",
                                  backgroundColor:
                                    theme == "dark" ? "rgb(30, 30, 47)" : "",
                                }}
                              >
                                <DropdownItem
                                  className={
                                    itemsPerPage == 10
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(10);
                                    setItemsToShow(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 25
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(25);
                                    setItemsToShow(25);
                                  }}
                                >
                                  25
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 50
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(50);
                                    setItemsToShow(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == "All"
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage("All");
                                    setItemsToShow(
                                      analysisNavData
                                        ?.map((ele) => {
                                          if (
                                            (!ele?.toNAV ||
                                              ele?.toNAV?.nav === 0) &&
                                            (!ele?.fromNAV ||
                                              ele?.fromNAV?.nav === 0)
                                          ) {
                                            return null;
                                          } else {
                                            return ele;
                                          }
                                        })
                                        ?.filter(Boolean)?.length
                                    );
                                  }}
                                >
                                  All
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          )}
                      </div>
                      <div className="col-md-4">
                        {itemsToShow <
                          analysisNavData
                            ?.map((ele) => {
                              if (
                                (!ele?.toNAV || ele?.toNAV?.nav === 0) &&
                                (!ele?.fromNAV || ele?.fromNAV?.nav === 0)
                              ) {
                                return null;
                              } else {
                                return ele;
                              }
                            })
                            ?.filter(Boolean)?.length &&
                          selectedValues?.columns?.length > 0 && (
                            <div className="d-flex justify-content-center my-2">
                              <button
                                className="btn btn-primary mt-3"
                                onClick={handleShowMore}
                              >
                                Show More
                              </button>
                            </div>
                          )}
                      </div>
                      <div className="col-md-4">
                        {analysisNavData
                          ?.map((ele) => {
                            if (
                              (!ele?.toNAV || ele?.toNAV?.nav === 0) &&
                              (!ele?.fromNAV || ele?.fromNAV?.nav === 0)
                            ) {
                              return null;
                            } else {
                              return ele;
                            }
                          })
                          ?.filter(Boolean)?.length &&
                          selectedValues?.columns?.length > 0 && (
                            <div className="d-flex align-items-center justify-content-end">
                              <div
                                id="TotalRecord_dropdown"
                                className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                                style={{
                                  borderRadius: "4px",
                                  color: theme == "light" ? "black" : "white",
                                  marginTop: "13px",
                                }}
                              >
                                Total record :{" "}
                                {selectedValues?.columns?.length > 0
                                  ? analysisNavData
                                    ?.map((ele) => {
                                      if (
                                        (!ele?.toNAV ||
                                          ele?.toNAV?.nav === 0) &&
                                        (!ele?.fromNAV ||
                                          ele?.fromNAV?.nav === 0)
                                      ) {
                                        return null;
                                      } else {
                                        return ele;
                                      }
                                    })
                                    ?.filter(Boolean)?.length
                                  : 0}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AnalysisNavReport;
